module.exports = __webpack_public_path__ + "img/IMG_6726_L_Wood.e996bada.jpg";